/**
 * @Author: zpc
 * @Description:
 * @DateTime: Created in 2021-12-15 16:59:00
 */

 import EnumItem, {enumMixn} from "./enumItem";

 /**
  * UPS状态
  */
 let EnumUpsState  = {
     "逆变"             : new EnumItem('逆变', "0"),
     "旁路"              : new EnumItem('旁路', "1"),
     ...enumMixn
 }
 export default EnumUpsState 